import { state } from './state.js';
import { escapeHtml as escapeAttr } from './helpers.js';

export function announceMapStatus(message = '') {
	const status = document.getElementById('map-directory-status');
	if (status) {
		status.textContent = message;
	}
}

export function setSidebarExpanded(isExpanded) {
	// #sidebar-toggler lives inside #sidebar-wrapper and must stay reachable even when
	// the results list is collapsed, so aria-hidden/inert target #map-sidebar (the
	// results content) rather than the whole wrapper.
	const sidebarContent = document.getElementById('map-sidebar');
	const toggles = document.querySelectorAll('#sidebar-toggler button, #online-business button');

	if (sidebarContent) {
		sidebarContent.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
		sidebarContent.inert = !isExpanded;
	}

	toggles.forEach(toggle => {
		toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
	});
}

export function syncFilterToggleState() {
	const isExpanded = $('#cat-contain').is(':visible');
	document.querySelectorAll('.cat-filter, .close-cat').forEach(button => {
		button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
	});
}

/**
 * Generate Card HTML
 */
export function generateCard(result = null, image = null, onlineOnly = false, onlineModal = false) {
	if (result === null || image === null) {
		return;
	}
	let resultHTMLDiv = document.createElement('div');
	resultHTMLDiv.classList.add('cell');
	let title = '';
	let id = '';
	let viewProfileId = '';
	let onlineMarker = '';
	let chamberBadge = '';
	
	const isMember = result?.item?.is_chamber_member || result?.item?.properties?.is_chamber_member || result?.is_chamber_member || false;
	if (isMember) {
		chamberBadge = `
			<div class="chamber-badge-container">
				<span class="chamber-badge">
					<span class="badge-icon"><img src="/wp-content/themes/bcc_theme/images/iconBcc.png" alt="Chamber Member"></span>
					Chamber Member
				</span>
			</div>`;
	}
	
	if (onlineOnly === false) {
		id = result.item.properties.post_id;
		viewProfileId = id;
		resultHTMLDiv.dataset.markerId = id;
		title = result?.item?.title;
	}
	if(onlineOnly === true && onlineModal === false){
		id = result?.item?.id;
		viewProfileId = `ob_${id}`;
		onlineMarker = '<div class="ob-tag"><i class="fas fa-mouse-pointer"></i> Online Business</div>';
		title = result?.item?.title;
		resultHTMLDiv.dataset.markerId = id;
		image = result?.item?.image[0] ?? '/wp-content/themes/bcc_theme/images/placeholder.png';
	}
	if (onlineModal === true) {
		id = result?.id;
		viewProfileId = `ob_${id}`;
		title = result?.title;
		resultHTMLDiv.dataset.markerId = id;
		image = result?.image[0] ?? '/wp-content/themes/bcc_theme/images/placeholder.png';
		onlineMarker = '';
	}
	
	const markerData = onlineOnly ? result?.item : result?.item?.properties;
	const lat = markerData?.lat || '';
	const lng = markerData?.lng || '';
	const placeId = markerData?.place_id || '';

	resultHTMLDiv.innerHTML = `
                             <div data-marker-id="${escapeAttr(id)}" class="grid-x grid-padding-x">
                                <div class="cell padb1">
                                     <h3>${escapeAttr(title)}</h3>
                                </div>
                             </div>
                             <div class="grid-x location-pic blur" data-background="${escapeAttr(image)}" style="background:url(/wp-content/themes/bcc_theme/images/placeholder.png) no-repeat center center; background-size: cover; transition: filter 0.4s ease-out;">
                            </div>
                                                                                             ${onlineMarker}
                                                                                             ${chamberBadge}
                            <div class="grid-x">
                                 <div class="cell padt1 padb1">
                                    <p class="seach-card-descripton blur">Description Goes Here</p>
                                    <div class="grid-x grid-padding-x align-middle">
                                        <div class="cell auto">
                                            <button type="button" class="button search-result-view-profile"
                                               data-id="${viewProfileId}"
                                               data-lat="${lat}"
                                               data-lng="${lng}"
                                               data-place-id="${placeId}"
                                               aria-label="View profile for ${escapeAttr(title)}"
                                               style="margin-bottom: 8px; width: 100%; font-size: 0.8rem; padding: 12px;">
                                               <i class="fas fa-map-marker-alt" aria-hidden="true"></i> VIEW PROFILE
                                            </button>
                                            <button type="button" class="interest-add-button button secondary"
                                               data-id="${id}"
                                               data-post-id="${id}"
                                               data-title="${escapeAttr(title)}"
                                               aria-label="Add ${escapeAttr(title)} to interests"
                                               style="margin-bottom: 0; width: 100%; font-size: 0.8rem; padding: 10px;">
                                               <i class="fas fa-heart" aria-hidden="true"></i> ADD TO INTERESTS
                                            </button>
                                        </div>
                                    </div>
                                 </div>
                            </div>`;
	return resultHTMLDiv;
}

/**
 * Generate Skeleton Card HTML
 */
export function generateSkeletonCard() {
	let skeleton = document.createElement('div');
	skeleton.classList.add('cell', 'skeleton-card');
	skeleton.innerHTML = `
		<div class="grid-x grid-padding-x">
			<div class="cell padb1">
				<div class="skeleton-text skeleton-title"></div>
			</div>
		</div>
		<div class="grid-x location-pic skeleton-image"></div>
		<div class="grid-x">
			<div class="cell padt1 padb1">
				<div class="skeleton-text skeleton-description"></div>
				<div class="skeleton-text skeleton-description" style="width: 80%;"></div>
			</div>
		</div>`;
	return skeleton;
}

/**
 * Generate Filter Pill
 */
export function generateFilterPill(title, cat_id, cat_color) {
	let parser = new DOMParser();
	let pill = `<div class="cat-active cat-pill"><button type="button" data-term-id="${escapeAttr(cat_id)}" style="background:${escapeAttr(cat_color)};" aria-label="Remove ${escapeAttr(title)} filter">x</button><span>${escapeAttr(title)}</span></div>`;
	let elem = parser.parseFromString(pill, 'text/html');
	return elem.body.firstElementChild;
}

/**
 * Cleanup Unused Pills
 */
export function cleanupUnusedPills() {
	const pillBar = document.getElementById('pill-bar');
	if (!pillBar) return;
	
	const activePills = pillBar.querySelectorAll('.cat-pill');
	activePills.forEach(pill => {
		const termId = pill.querySelector('button').dataset.termId;
		const isIncluded = state.filterCategories.some(catId => String(catId) === String(termId));
		if (!isIncluded) {
			pill.remove();
		}
	});
}
